import {Injectable} from '@angular/core';
import {DateValidator} from '../../modules/UIKit/validators/DateValidator';
import { MessageService } from 'primeng/api';

@Injectable()
export class DateService {

  constructor (private messageService: MessageService) { }

  addDaysToDate(date: Date, days: number): Date {
    return new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
  }

  addMaxDaysToDate(date: Date) : Date {
    return this.addDaysToDate(date, 365);
  }

  validateRange(dateMin: Date, dateMax: Date)  {
    let validator = new DateValidator();
    let v = validator.isValid(dateMin, dateMax, '<=');
    if (!v) {
      this.messageService.add({severity: 'error', summary: 'Error', detail: 'Invalid date range'});
    }
    return v;

  }


}



// WEBPACK FOOTER //
// ./src/app/services/application/date.service.ts